import type { QuickSearchGroup } from '../types/group';
import type { QuickSearchItem } from '../types/item';
type Groups = { group?: QuickSearchGroup; items: QuickSearchItem[] }[];
type State = { groups: Groups; selectedValue: string };
type Action =
  | { type: 'select'; payload: string }
  | { type: 'reset-select' }
  | { type: 'update-groups'; payload: Groups };
const first = (groups: Groups) =>
  groups.flatMap(g => g.items).find(i => !i.disabled)?.id ?? '';
const contains = (groups: Groups, id: string) =>
  groups.some(g => g.items.some(i => i.id === id && !i.disabled));
export function searchSelectionReducer(state: State, action: Action): State {
  if (action.type === 'select')
    return {
      ...state,
      selectedValue: contains(state.groups, action.payload)
        ? action.payload
        : first(state.groups),
    };
  if (action.type === 'reset-select')
    return { ...state, selectedValue: first(state.groups) };
  return {
    groups: action.payload,
    selectedValue:
      state.selectedValue !== first(state.groups) &&
      contains(action.payload, state.selectedValue)
        ? state.selectedValue
        : first(action.payload),
  };
}
